/**
 * @flow
 * @file Content Uploader Popup Component
 * @author Box
 */

import makePopup from '../common/makePopup';
import ContentUploader from './ContentUploader';
import { CLIENT_NAME_CONTENT_UPLOADER } from '../../constants';

export default makePopup(CLIENT_NAME_CONTENT_UPLOADER)(ContentUploader);
